import { render, staticRenderFns } from "./QuadrupleBanner.vue?vue&type=template&id=d27bf892&scoped=true"
import script from "./QuadrupleBanner.vue?vue&type=script&lang=js"
export * from "./QuadrupleBanner.vue?vue&type=script&lang=js"
import style0 from "./QuadrupleBanner.vue?vue&type=style&index=0&id=d27bf892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27bf892",
  null
  
)

export default component.exports